import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import { changeFilter, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import { expandEffectsList } from '../../actions/MenuActions';
import storeManager from '../../store/StoreManager';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    selectedFilter () {
        if (!this.props.contextTarget)
            return 2;

        return this.props.selectedEffect;
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    updateThumbnail() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var selectedFilter = this.selectedFilter();

        switch (this.props.index) {
            case 0: {
                // Shadow
                if (selectedFilter != 0) {
                    this.props.dispatch(changeFilter(this.props.contextTarget, ''));
                    setTimeout(this.addShadow, 3);
                }
                break;
            }

            case 1: {
                // Silhouette
                if (selectedFilter != 1) {
                    this.props.dispatch(changeFilter(this.props.contextTarget, ''));
                    setTimeout(this.addSilhouette, 3);
                }
                break;
            }

            case 2: {
                // None
                if (selectedFilter != 2)
                    this.props.dispatch(changeFilter(this.props.contextTarget, ''));
                break;
            }
        }

        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);

        this.updateThumbnail();
    },
    addShadow() {
        this.props.dispatch(changeFilter(this.props.contextTarget, 'url(#2)'));
        saveManager.isContentChanged(true);
    },
    addSilhouette() {
        this.props.dispatch(changeFilter(this.props.contextTarget, 'url(#5)'));
        saveManager.isContentChanged(true);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.selectedEffect != newProps.selectedEffect || this.props.contextTarget != newProps.contextTarget)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;

        if (this.state.isOver == true) {
            iconColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        var topPosition = this.props.index * properties.EFFECTS_BUTTON_HEIGHT;

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth - 3 * properties.EFFECTS_PADDING  - 2 * 14,
            height: properties.EFFECTS_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            color: 'white',
            margin: 0,
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            textAlign: 'left'
        };

        const spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 15,
            top: 0
        };

        var iconVisible;

        if (this.props.index == this.selectedFilter())
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const iconStyle = {
            position: 'absolute',
            top: 11,
            right: 20,
            color: iconColor,
            display: iconVisible
        };

        var idValue;

        if (this.props.index == 2)
            idValue = 'objectContextLastFocusableElement';

        return (
            <button id={idValue} aria-label={this.props.text} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{this.props.text}</span>
                <i style={iconStyle} className='fa fa-check'></i>
            </button>
        );
    }
});

export const EffectsMenuContent = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onExpand (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const isExpanded = !this.props.effectsListIsExpanded;

        this.props.dispatch(expandEffectsList(isExpanded));
    },
    onListChanged (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        setTimeout(this.refreshView, 6);
    },
    refreshView() {
        this.forceUpdate();
    },
    selectedFilter () {
        if (!this.props.contextTarget)
            return 2;

        const state = storeManager.getState();
        const uuid = this.props.contextTarget.uuid;
        const shapes = state.currentSlide.model.content;
        var i;
        var target;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].uuid == uuid) {
                target = shapes[i];
                break;
            }
        }

        if (target == undefined || target.filter == undefined)
            return 2;

        var filterIndex;
        const filter = target.filter;
        
        if (filter.length < 1) // None
            filterIndex = 2;
        else {
            if (filter.indexOf('2') != -1) // Shadow
                filterIndex = 0;
            else if (filter.indexOf('5') != -1) // Silhouette
                filterIndex = 1;
            else
                filterIndex = 2;
        }

        return filterIndex;
    },
    getSelectedEffectTitle () {
        const index = this.selectedFilter();
        var effectTitle;

        switch (index) {
            case 0: {
                effectTitle = locales.getCaption('Shadow', 'advancedMenu');
                break;
            }
            case 1: {
                effectTitle = locales.getCaption('Silhouette', 'advancedMenu');
                break;
            }
            case 2: {
                effectTitle = locales.getCaption('None', 'advancedMenu');
                break;
            }
        }

        return effectTitle;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.contextTarget != newProps.contextTarget || this.props.accordionWidth != newProps.accordionWidth || this.props.effectsListIsExpanded != newProps.effectsListIsExpanded)
            return true;
        else
            return false;
    },
    render() {
        const topPadding = 5;
        const gap = 2;
        var buttonTopPosition = properties.OBJECT_ADVANCED_MIDDLE_GAP + 6;

        const effectsStyle = {
            position: 'absolute',
            top: this.props.top + topPadding,
            right: 0,
            width: this.props.accordionWidth,
            height: properties.EFFECTS_BUTTON_HEIGHT * 4 + topPadding + gap + 1 + buttonTopPosition,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        const titleHolderStyle = {
            position: 'absolute',
            top: 0,
            left: properties.EFFECTS_PADDING
        };

        const frontIconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            color: 'black'
        };

        const titleStyle = {
            position: 'absolute',
            color: 'black',
            cursor: 'default',
            fontSize: 16,
            top: 0,
            left: 25
        };

        var borderColor;
        var textColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = properties.EFFECTS_BUTTON_BORDER_COLOR;
            textColor = 'black';
        }

        const effectsButtonStyle = {
            width: this.props.accordionWidth - 2 * properties.EFFECTS_PADDING,
            height: properties.EFFECTS_BUTTON_HEIGHT,
            background: 'white',
            borderRadius: 50,
            position: 'absolute',
            left: properties.EFFECTS_PADDING,
            top: buttonTopPosition,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            alignItems: 'center',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            textAlign: 'left'
        };

        var icon;

        if (this.props.effectsListIsExpanded == true)
            icon = 'fa fa-angle-down';
        else
            icon = 'fa fa-angle-right';

        const effectsIconStyle = {
            position: 'absolute',
            top: 12,
            right: 21,
            color: textColor
        };

        const spanStyle = {
            position: 'absolute',
            color: textColor,
            cursor: 'default',
            fontSize: 16,
            top: 11,
            paddingLeft: 24
        };

        var elements = [];
        var listDisplay;

        if (this.props.effectsListIsExpanded == true) {
            const selectedEffect = this.selectedFilter();

            elements.push(<Button accordionWidth={this.props.accordionWidth} index={0} selectedEffect={selectedEffect} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} key='Shadow' text={locales.getCaption('Shadow', 'advancedMenu')}/>);
            elements.push(<Button accordionWidth={this.props.accordionWidth} index={1} selectedEffect={selectedEffect} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} key='Silhouette' text={locales.getCaption('Silhouette', 'advancedMenu')}/>);
            elements.push(<Button accordionWidth={this.props.accordionWidth} index={2} selectedEffect={selectedEffect} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} key='None' text={locales.getCaption('None', 'advancedMenu')}/>);
            listDisplay = 'block';
        }   else {
            listDisplay = 'none';
        }

        const effectsListStyle = {
            position: 'absolute',
            width: this.props.accordionWidth - 2 * properties.EFFECTS_PADDING - 2 * properties.EFFECTS_CORNER_GAP + 2,
            height: properties.EFFECTS_BUTTON_HEIGHT * 3,
            top: properties.EFFECTS_BUTTON_HEIGHT + 2 + buttonTopPosition,
            left: properties.EFFECTS_PADDING + properties.EFFECTS_CORNER_GAP,
            borderColor: properties.EFFECTS_BUTTON_BORDER_COLOR,
            borderWidth: 1,
            borderStyle: 'solid',
            display: listDisplay
        };

        var idVal = this.props.id;

        if (this.props.effectsListIsExpanded == true)
            idVal = '';

        return (
            <div id='effectsMenu' style={effectsStyle}>
                <div style={titleHolderStyle}>
                    <i style={frontIconStyle} className='fa fa-magic'></i>
                    <span style={titleStyle}>{locales.getCaption('EffectsTitle', 'advancedMenu')}</span>
                </div>
                <button id={idVal} aria-label={this.getSelectedEffectTitle()} style={effectsButtonStyle} onTouchEnd={this.onExpand} onClick={this.onExpand} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                    <span style={spanStyle}>{this.getSelectedEffectTitle()}</span>
                    <i style={effectsIconStyle} className={icon}></i>
                </button>
                <div style={effectsListStyle} onTouchEnd={this.onListChanged} onClick={this.onListChanged}>
                    {elements}
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const effectsListIsExpanded = state.menu.effectsListIsExpanded;

    return {
        effectsListIsExpanded
    };
}

export const EffectsMenu = connect(mapStateToProps)(EffectsMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/EffectsMenu.js
 **/